import React, { Component } from "react";
import { Spinner } from "./Spinner";
import { Tooltip } from "@material-ui/core/";

import IconButton from "@material-ui/core/IconButton";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import PersonIcon from "@material-ui/icons/Person";

import { LoggedUserContext } from "../LoggedUserContext";

import { acquireToken } from "../adalConfig";
import axios from "axios";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

export class CampaignsDownloadExcelReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      type: props.type,
      info: props.info,
      loading: false,
      url: "",
    };
  }
  static propTypes = {};

  async componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.loadData();
    }
  };

  loadData() {
    this.setState({ loading: true });
    const URL = `${process.env.REACT_APP_API_URL}/CampaingAPI/DownloadPeopleFromCampaingExcelReport/${this.props.value}/${this.props.type}/${this.props.info}`;
    this.setState({ url: URL });
    this.setState({ loading: false });
  }

  render() {
    const { loading, info } = this.state;
    return loading ? (
      <Spinner />
    ) : info === "Email" ? (
      <div>
        <Tooltip title="Download the list of emails">
          <IconButton
            style={{ backgroundColor: "#797991" }}
            aria-label="Download the list of emails"
            onClick={() => {
              this.DownloadData("Campaign user emails");
            }}
          >
            <AlternateEmailIcon style={{ color: "#FFFFFF" }} />
          </IconButton>
        </Tooltip>
      </div>
    ) : (
      <div>
        <Tooltip title="Download people details">
          <IconButton
            style={{ backgroundColor: "#797991" }}
            aria-label="download"
            onClick={() => {
              this.DownloadData("Campaign user details");
            }}
          >
            <PersonIcon style={{ color: "#FFFFFF" }} />
          </IconButton>
        </Tooltip>
      </div>
    );
  }

  DownloadData(title) {
    this.setState({ loading: true });
    acquireToken().then((token) => {
      axios
        .get(this.state.url, {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/excel" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${title}.xlsx`);
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(link);
          this.setState({ loading: false });
        })
        .catch((err) => {
          MySwal.fire({
            icon: "error",
            title: "An error has occurred while downloading the file",
            text: err,
            confirmButtonColor: "#FFE600",
            confirmButtonText: "<div style='color: black'>OK</div>",
          });
        });
    });
  }
}

CampaignsDownloadExcelReports.contextType = LoggedUserContext;

export default CampaignsDownloadExcelReports;
